<template>
  <div class="box online_bg">
    <div class="wrap w1200">
      <!--右侧列表-->
      <div class="w1200 onsite_b task_jihua_list">
        <h5 class="none_ts" v-if="!lists || lists.length == '0'">
          <img src="@/assets/images/none_data.jpg" alt="">
          <h4>暂无计划</h4>
        </h5>
        <dl v-for="item in lists" v-bind:key="item.id">
          <dt>
            <span class="btn_px" v-if="getStatus(item) == '培训中'">{{getStatus(item)}}</span>
            <span class="btn_end" v-if="getStatus(item) == '培训未开始'">{{getStatus(item)}}</span>
            <span class="btn_end" v-if="getStatus(item) == '培训已结束'">{{getStatus(item)}}</span>
            <img src="@/assets/images/zy_2.jpg" v-if="!item.coverUrl || item.coverUrl == ''" />
            <img :src="item.coverUrl" v-if="item.coverUrl && item.coverUrl !== ''">
          </dt>
          <dd>
            <h3>{{item.title}}
              <span v-if="item.price && item.price > 0">￥<span style="color: #ff3633;
    font-size: 24px;">{{item.price}}</span>元</span>
              <span v-if="!item.price || item.price <= 0" style="display: inline-block; font-size: 14px; line-height: 14px; background: #ff3633; border-radius: 5px; color: white; padding: 5px;">免费</span>
            </h3>
            <p class="time_t">{{ dateFormat(new Date(item.beginDate), 'yyyy-MM-dd hh:mm:ss') }} 至 {{ dateFormat(new Date(item.endDate), 'yyyy-MM-dd hh:mm:ss') }}</p>
            <!--a href="javascript:void(0);" class="zan">139</a>
            <a href="javascript:void(0);" class="fav">139</a-->
            <a class="a_detail" @click="to('plan', item.id)" style="cursor: pointer;">查看详情</a>
          </dd>
        </dl>
        <div class="onsite_list_bottom mtf30">
          <div v-if="cntData > 0">共<b>{{cntData}}</b>条</div>
          <div v-if="cntData > 0">
            <paginate :click-handler="clickCallback" :page-count=pages
                      :container-class=$global.paginationOptions.container_class :page-class=$global.paginationOptions.page_class :page-link-class=$global.paginationOptions.page_link_class
                      :prev-class=$global.paginationOptions.prev_class :prev-link-class=$global.paginationOptions.prev_link_class
                      :next-class=$global.paginationOptions.next_class :next-link-class=$global.paginationOptions.next_link_class
                      :first-last-button=$global.paginationOptions.first_last_button
                      :active-class=$global.paginationOptions.active_class
                      :disabled-class=$global.paginationOptions.disabled_class
                      :first-button-text=$global.paginationOptions.first_button_text
                      :last-button-text=$global.paginationOptions.last_button_text
                      :prev-text=$global.paginationOptions.prev_text
                      :next-text=$global.paginationOptions.next_text>
            </paginate>
          </div>
        </div>
      </div>
      <!--/右侧列表-->
      <div class="clear"></div>
    </div>

  </div>
</template>
<script>
  import config from '@/config'
  import api from '@/api'
  import utils from '@/utils'
  import Paginate from 'vuejs-paginate'
  export default {
    components: { Paginate },
    data () {
      return {
        filters: {
          pageNo: 1,
          pageSize: 12,
          isPublished: '1'
        },
        lists: [],
        pages: 0,
        cntData: '',
        pool: {
          information_type: {}
        }
      }
    },
    created () {
      this.search(this.filters)
    },
    mounted () {
    },
    methods: {
      dateFormat: utils.dateFormat,
      getStatus (item) {
        var now = new Date()
        var begin = new Date(item.beginDate)
        var end = new Date(item.endDate)
        if (end < now) {
          return '培训已结束'
        } else if (begin > now) {
          return '培训未开始'
        } else {
          return '培训中'
        }
      },
      clickCallback (pageNum) {
        this.filters.pageNo = pageNum
        this.search(this.filters)
      },
      to (path, id) {
        this.$router.push({
          path: path + '/' + id
        })
      },
      search (filters) {
        api.post(config.bylApiPath, '/studyItemScopes/findPlanList', filters, (r) => {
          this.lists = r.data
          this.cntData = r.cntData
          this.pages = r.cntPage
        })
      }
    }
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/page/modules/plan/list.vue